export const CASH_DISCOUNT_PAYMENT_TYPE_OPTIONS = [
	{slug: 'cash', label: 'Cash', locked: true},
	{slug: 'check', label: 'Check'},
	{slug: 'gift', label: 'Gift Cert.'},
	{slug: 'invoice', label: 'To Invoice'},
	{slug: 'zelle', label: 'Zelle', requiresAllow: 'allow_zelle'},
	{slug: 'debit', label: 'Debit Card', requiresAllow: 'allow_debit'},
];

/**
 * @param {string|string[]|null|undefined} raw
 * @param {boolean} [allowZelle=true]
 * @param {boolean} [allowDebit=true]
 * @returns {string[]}
 */
export function parseCashDiscountPaymentTypes(raw, allowZelle = true, allowDebit = true) {
	let slugs = [];
	if (Array.isArray(raw)) {
		slugs = raw;
	} else if (typeof raw === 'string' && raw.trim() !== '') {
		try {
			const decoded = JSON.parse(raw);
			if (Array.isArray(decoded)) {
				slugs = decoded;
			}
		} catch (e) {
			slugs = [];
		}
	}

	const allowed = new Set(['cash', 'check', 'gift', 'invoice']);
	if (allowZelle) {
		allowed.add('zelle');
	}
	if (allowDebit) {
		allowed.add('debit');
	}

	const normalized = new Set(['cash']);
	slugs.forEach((slug) => {
		const value = String(slug || '').toLowerCase().trim();
		if (allowed.has(value)) {
			normalized.add(value);
		}
	});

	return Array.from(normalized);
}

export function stringifyCashDiscountPaymentTypes(slugs, allowZelle = true, allowDebit = true) {
	return JSON.stringify(parseCashDiscountPaymentTypes(slugs, allowZelle, allowDebit));
}

/**
 * @param {object} state Checkout component state
 * @returns {string[]}
 */
export function selectedCheckoutDiscountSlugs(state) {
	const slugs = [];
	if (state?.showCashField) {
		slugs.push('cash');
	}
	if (state?.showCheckField) {
		slugs.push('check');
	}
	if (state?.showGiftCertField) {
		slugs.push('gift');
	}
	if (state?.showInvoiceField) {
		slugs.push('invoice');
	}
	if (state?.showZelleField) {
		slugs.push('zelle');
	}
	if (state?.showDebitCardButtons) {
		slugs.push('debit');
	}
	return slugs;
}

/**
 * @param {object} rootState
 * @param {object} checkoutState
 * @returns {boolean}
 */
export function shouldApplyCashDiscount(rootState, checkoutState) {
	if (!rootState?.cash_discounting || !rootState?.cash_discount_percentage) {
		return false;
	}
	const allowed = parseCashDiscountPaymentTypes(
		rootState.cash_discount_payment_types,
		!!rootState.allow_zelle,
		!!rootState.allow_debit
	);
	return selectedCheckoutDiscountSlugs(checkoutState).some((slug) => allowed.includes(slug));
}
